export {
  useEditState,
  type EditStateCallback,
  type EditStateCallbackEvents,
  type EditStateResetCallback,
} from "app-base/react/edit-state"
